// https://github.com/aws-amplify/amplify-cli/issues/2420

//###############################################
// Inventory By Load Type  /reportInventoryByLoadType
//###############################################
export const countInventoryByCommodity = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        inboundShipmentId
        reloadYardCommodity {
          commodity {
            id
            name
          }
        }
      }
      total
    }
  }
`;

//###############################################
// TotalInOutReport  /reportTotalInOut
//###############################################
export const searchInboundTotal = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        state
        accountName
        poNumber
        lotNumber
        notifyDateTime
        placedDateTime
        releaseDateTime
        inventories {
          items {
            id
            status
            productId
            productName
            productCode
            quantityAdvised
            quantityReceived
            inventoryUOM
            reloadYardCommodityId
          }
        }
        totalUOM
      }
      nextToken
      total
    }
  }
`;

export const searchOutboundTotal = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        status
        accountName
        transfer
        poNumber
        arrivalDateTime
        placementDateTime
        departureDateTime
        totalUOM
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        shipmentLineItems {
          items {
            id
            status
            totalQuantityToPick
            inventoryId
            inventory {
              id
              productId
              productCode
              productName
              inventoryUOM
              reloadYardCommodityId
            }
          }
        }
      }
      nextToken
      total
    }
  }
`;

//###############################################
// InventoryActivityReport  /reportInventoryActivity
//###############################################
export const searchInventorysActivity = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        lotNumber
        poNumber
        railCarNumber
        containerNumber
        quantityReceived
        quantityOnHand
        quantityCommitted
        inventoryUOM
        receivedAt
        depletedAt
        productName
        productCode
        inboundShipmentId
        shipmentLineItems {
          items {
            id
            status
            totalQuantityToPick
            outboundShipmentId
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const getOutboundShipmentActivity = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      status
      state
      transfer
      transferToAccountName
      poNumber
      pickupNumber
      shipTo {
        name
      }
      carrierName
      railCarNumber
      arrivalDateTime
      placementDateTime
      departureDateTime
      collectedDateTime
      tareWeight
      ladenWeight
      weightUnits
      scaleWeightUnits
      totalUOM
      shipmentLineItems {
        items {
          id
          totalQuantityToPick
          outboundShipmentId
          inventoryId
          sortKey
          inventory {
            id
            productName
            productCode
            weight
            weightUOM
            inventoryUOM
          }
        }
        nextToken
      }
      reloadYardCommodityId
    }
  }
`;

//###############################################
// InboundInvoiceReport  /reportInboundInvoices
//###############################################
export const searchInboundInvoices = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        state
        poNumber
        lotNumber
        lotType
        railCarNumber
        totalUOM
        placedDateTime
        accountName
        invoiceId
        inventories {
          items {
            quantityAdvised
            quantityReceived
            inventoryUOM
            product {
              id
              defaultUOM
              unit
              pcs
              mbf
              lf
              sf
              msf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
              ft
              m
            }
          }
        }
        invoice {
          status
          invoiceNumber
          poNumber
          sentDate
          paidDate
          # settledDate removed 1.3.12
          subtotal
          tax
          total
          balance
          inboundShipmentId
          outboundShipmentId
          lineItems {
            items {
              service {
                name
                description
              }
              quantity
              units
              unitCost
              amount
              itemTax
              serviceNote
            }
            nextToken
          }
          createdAt
        }
        customFields
      }
      nextToken
      total
    }
  }
`;

//###############################################
// OutboundInvoiceReport  /reportOutboundInvoices
//###############################################
export const searchOutboundInvoices = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        state
        transfer
        transferToAccountName
        poNumber
        pickupNumber
        bolNumber
        railCarNumber
        departureDateTime
        totalUOM
        accountName
        invoiceId
        shipmentLineItems {
          items {
            totalQuantityToPick
            totalQuantityReturned
            inventoryItems {
              items {
                quantityReturned
              }
            }
          }
        }
        invoice {
          status
          invoiceNumber
          poNumber
          sentDate
          paidDate
          subtotal
          tax
          total
          balance
          inboundShipmentId
          outboundShipmentId
          lineItems {
            items {
              service {
                name
                description
              }
              quantity
              units
              unitCost
              amount
              itemTax
              serviceNote
            }
            nextToken
          }
          createdAt
        }
        customFields
        createdAt
      }
      nextToken
      total
    }
  }
`;

//###############################################
// InventoryStorageReport  /reportInventoryStorage
//###############################################
export const searchInventoryStorage = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        accountId
        poNumber
        railCarNumber
        quantityReceived
        quantityOnHand
        inventoryUOM
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        weight
        weightUOM
        receivedAt
        depletedAt
        turnDays
        productName
        productCode
        product {
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          pcsHeight
          pcsWidth
          pcsLength
        }
        inventoryItems {
          items {
            id
            status
            areaId
            zoneId
            quantityOnHand
            depletedAt
          }
        }
        reloadYardCommodityId
        inboundShipmentId
        inboundShipment {
          status
          carrierType
          carrierEquipmentTypeId
          areaId
          zoneId
          accountId
          poNumber
          railCarNumber
          releaseDateTime
          collectedDateTime
        }
        shipmentLineItems {
          items {
            id
            status
            totalQuantityToPick
            updatedAt
            outboundShipment {
              departureDateTime
            }
            inventoryItems {
              items {
                id
                inventoryItemId
                quantityToPick
                updatedAt
              }
            }
          }
        }
      }
      nextToken
      total
    }
  }
`;

// Per-car storage billing: cars are billed per railcar from the InboundShipment
// record itself, so a SIT car's empty tally sheet (no Inventory rows) still
// bills, and a tracked car whose stock was depleted before the period still
// bills for the days it sat on the track into it. See
// processInventoryStorageReportData / buildShipmentBillableRecord.
export const searchStorageShipments = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        sit
        skipInvoice
        accountId
        accountName
        poNumber
        railCarNumber
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        reloadYardCommodityId
        placedDateTime
        releaseDateTime
        collectedDateTime
      }
      nextToken
      total
    }
  }
`;

//###############################################
// AvgInboundCarsByAccount  /reportCarsByAccount
//###############################################
export const listAccountNames = /* GraphQL */ `
  query AccountByActiveByName(
    $reloadYardId: ID
    $activeBusinessName: ModelAccountAccountByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountByActiveByName(
      reloadYardId: $reloadYardId
      activeBusinessName: $activeBusinessName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessName
        displayName
      }
      nextToken
    }
  }
`;

//###############################################
// AvgInventoryTurns
//###############################################
export const searchInventorys = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        depletedAt
        turnDays
      }
      nextToken
      total
    }
  }
`;

//###############################################
// AvgInventoryTurnsByAccount  /reportTurnoverByAccount
//###############################################
export const countInventoryTurns = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        turnDays
      }
      total
    }
  }
`;

//###############################################
// InventoryRecallReport  /reportInventoryRecall
//###############################################
export const searchInventorysRecall = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        lotNumber
        poNumber
        railCarNumber
        quantityReceived
        quantityOnHand
        inventoryUOM
        receivedAt
        productName
        productCode
        customFields
        inboundShipmentId
        inboundShipment {
          customFields
        }
        shipmentLineItems {
          items {
            id
            totalQuantityToPick
            outboundShipmentId
            outboundShipment {
              status
              transfer
              transferToAccountName
              poNumber
              pickupNumber
              shipTo {
                name
                street
                city
                state
                zipCode
                country
              }
              carrierName
              railCarNumber
              departureDateTime
              customFields
            }
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const searchInvoicesForReport = /* GraphQL */ `
  query SearchInvoices(
    $filter: SearchableInvoiceFilterInput
    $sort: SearchableInvoiceSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInvoices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        status
        total
        balance
        event
        inboundShipmentId
        outboundShipmentId
        createdAt
      }
      nextToken
      total
    }
  }
`;

//###############################################
// InvoiceService Report  /reportInvoiceServices
//###############################################
export const searchInvoiceServicesForReport = /* GraphQL */ `
  query SearchInvoiceServices(
    $filter: SearchableInvoiceServiceFilterInput
    $sort: SearchableInvoiceServiceSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInvoiceServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        invoiceId
        serviceId
        accountId
        reloadYardId
        quantity
        unitCost
        amount
        itemTax
        itemTotal
        taxRate {
          taxCode
          name
          taxRate
        }
        serviceNote
        serviceDate
        invoice {
          id
          invoiceNumber
          poNumber
          dueDate
          createdAt
          sentDate
          paidDate
          paymentTerms
          notes
          accountName
          accountId
          status
        }
        service {
          id
          name
          description
        }
        event
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          carrierType
          railCarNumber
          poNumber
        }
        outboundShipment {
          id
          carrierType
          railCarNumber
          pickupNumber
        }
      }
      nextToken
      total
    }
  }
`;

//###############################################
// OpenOrdersReport  /reportOpenOrders
//###############################################
export const searchInboundOpen = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        poNumber
        lotNumber
        railCarNumber
        carrierName
        placedDateTime
        # totalUOM
        # inventories {
        #   items {
        #     id
        #     productName
        #     productCode
        #     quantityAdvised
        #     quantityReceived
        #     inventoryUOM
        #   }
        # }
      }
      nextToken
      total
    }
  }
`;

export const searchOutboundOpen = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        transfer
        poNumber
        pickupNumber
        railCarNumber
        carrierName
        arrivalDateTime
        placementDateTime
        # totalUOM
        # shipmentLineItems {
        #   items {
        #     id
        #     status
        #     totalQuantityToPick
        #     inventoryId
        #     inventory {
        #       id
        #       productCode
        #       productName
        #       inventoryUOM
        #     }
        #   }
        # }
      }
      nextToken
      total
    }
  }
`;

//###############################################
// RailcarsProcessedReport  /reportRailcarsProcessed
//###############################################
export const searchInboundRailcars = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        sit
        accountId
        accountName
        carrierName
        railCarNumber
        notifyDateTime
        placedDateTime
        releaseDateTime
        collectedDateTime
      }
      nextToken
      total
    }
  }
`;

export const searchOutboundRailcars = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        accountId
        accountName
        carrier
        carrierName
        railCarNumber
        arrivalDateTime
        placementDateTime
        departureDateTime
        collectedDateTime
      }
      nextToken
      total
    }
  }
`;
